import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'
import { useAppStore } from '../stores/app'

export default defineNuxtPlugin({
  name: 'shared-app-store',
  dependsOn: ['pinia'],
  setup(nuxtApp) {
    const runtimeConfig = useRuntimeConfig()
    const appStore = useAppStore(nuxtApp.$pinia)

    appStore.setRuntimeContext({
      apiBase: runtimeConfig.public.apiBase ?? '',
      appEnv: runtimeConfig.public.appEnv ?? '',
      platformName: runtimeConfig.public.platformName ?? 'Web',
      siteName: runtimeConfig.public.siteName ?? 'WikiBit',
      hydrateOnVisibleRootMargin: Number(runtimeConfig.public.hydrateOnVisibleRootMargin ?? 300),
    })

    // 将 cache-vary-country 中间件计算的页面缓存状态桥接到客户端 useState
    if (import.meta.server) {
      const cacheStatus = (nuxtApp.ssrContext?.event as any)?.context?._cacheStatus
      if (cacheStatus) useState('page-cache-status', () => cacheStatus)
    }
  },
})
